import * as React from "react";

import { cn } from "@/lib/utils";

export type InputProps = React.InputHTMLAttributes<HTMLInputElement>;

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = "text", ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        /*
         * No focus ring here, by rule and not by omission: `:focus-visible` matches a text field
         * on every path, so a halo would also land when a dialog focuses its own search field on
         * open. The signal is the bottom rule going to 2px in green (§ Acessibilidade, WCAG 2.4.7).
         */
        "flex h-11 w-full rounded-none border-0 border-b-[1.5px] border-solid border-b-[color:var(--tb-border-strong)] bg-transparent py-2.5 text-base text-[var(--fg)] outline-none transition-colors placeholder:text-[var(--fg-subtle)] hover:border-b-tb-oxide focus:border-b-2 focus:border-b-tb-green aria-[invalid=true]:border-b-[color:var(--tb-error)] disabled:cursor-not-allowed disabled:border-dashed disabled:text-[var(--fg-subtle)]",
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = "Input";
